import React from 'react';
import { Route, RouteProps } from 'react-router';
import { memoizedNest } from 'utils/nest';
import CardSelectorRoute from 'routes/CardSelectorRoute';
import ApplicationRoute from 'routes/ApplicationRoute';

type PropType = RouteProps & {
  wrappers: React.ComponentType[];
};

const WrappedRoute: React.FC<PropType> = ({
  wrappers,
  component: Component,
  ...rest
}) => {
  // Ensure that CardSelectorRoute comes before ApplicationRoute,
  // so that the embedded back button appears after the card selector widget
  const Wrapper = memoizedNest(
    ...(wrappers.includes(CardSelectorRoute) &&
    wrappers.includes(ApplicationRoute)
      ? [
          CardSelectorRoute,
          ApplicationRoute,
          ...wrappers.filter(
            wrapper =>
              wrapper !== CardSelectorRoute && wrapper !== ApplicationRoute,
          ),
        ]
      : wrappers),
  );

  return (
    <Route
      render={routeProps =>
        Component && (
          <Wrapper>
            <Component {...routeProps} />
          </Wrapper>
        )
      }
      {...rest}
    />
  );
};

export default WrappedRoute;
